import * as React from 'react';

export interface SidebarHeaderNextProps {
  children?: React.ReactNode;
  dataHook?: string;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
}

export default class SidebarHeaderNext extends React.PureComponent<SidebarHeaderNextProps> {}
